import * as React from 'react';
import { FileReference } from '../../amorg-common';
import { LinkReference } from '../../amorg-common/DTOs/ReferenceLink';
import { Flex } from './FlexHelpers';
import { Tabber, TabItem } from '../Tabber';
import { ReferenceFilesPanel } from './ReferenceFilesPanel';
import { CommentPanel } from './CommentPanel';
import { ProtectedPageContext } from '../../pages/_contexts/ProtectedPageContext';
import { Card, CardVariant } from '../Card';
import { ReferenceLinksPanel } from './ReferenceLinksPanel';
import { ToggletipTheOne } from '../ToggletipTheOne';
import { CommentReference } from '../../amorg-common';

type FileLinkCommentPanelProps = {
    fileReference?: FileReference,
    linkReference?: LinkReference,
    cardVariant?: CardVariant,
    commentReference?: CommentReference,
    hideTabber?: boolean,
    stretch?: boolean,
    tooltip?:React.ReactNode,
    maxHeightPx?: number,
    selectedTab?: 'files' | 'links' | 'comments'
};
export function FileLinkCommentPanel (props: FileLinkCommentPanelProps): JSX.Element
{
    const [selectedTab, setSelectedTab] = React.useState<'files' | 'links' | 'comments'>(
        props.fileReference
            ? 'files'
            : props.linkReference
                ? 'links'
                : 'comments'
    );
    const [fileCount, setFileCount] = React.useState<number | undefined>(undefined);
    const [linkCount, setLinkCount] = React.useState<number | undefined>(undefined);
    const [commentCount, setCommentCount] = React.useState<number | undefined>(undefined);

    React.useEffect(() => {
        if (props.selectedTab) {
            setSelectedTab(props.selectedTab);
        }
    }, [props.selectedTab]);

    if (!props.fileReference && !props.linkReference && !props.commentReference)
        throw new Error('At least one of fileReference, linkReference or commentReference must be provided');

    const activeUser = React.useContext(ProtectedPageContext).user;

    const tabItems: TabItem[] = [
        {
            tabName: 'files', text: 'Vedhæftede filer',
            hidden: !props.fileReference,
            avatarCount: fileCount === undefined ? undefined : fileCount
        },
        {
            tabName: 'links', text: 'Links',
            avatarCount: linkCount === undefined ? undefined : linkCount,
            hidden: !props.linkReference
        },
        {
            tabName: 'comments', text: 'Kommentarer',
            hidden: !props.commentReference,
            avatarCount: commentCount === undefined ? undefined : commentCount
        }
    ];

    return (

        <Flex flexDirection="column" justifyContent='stretch' grow={props.stretch ? '1' : '0'} gap={8} style={{minWidth:0}}>

            {!props.hideTabber &&
                <Flex justifyContent='space-between' alignItems='center' grow='0'>
                    <Tabber
                        variant='text'
                        inline
                        selectedTabName={selectedTab}
                        items={tabItems}
                        onClick={(tabName) => setSelectedTab(tabName as 'files' | 'links' | 'comments')}
                    />
                    {props.tooltip &&
                        <ToggletipTheOne>{props.tooltip}</ToggletipTheOne>
                    }
                </Flex>
            }

            <Card variant={props.cardVariant || 'outlined'} padding='5px 5px 5px 5px' flex flexGrow='1'>

                {props.fileReference &&
                    <ReferenceFilesPanel
                        hide={selectedTab !== 'files'}
                        referenceType={props.fileReference.type}
                        objectId={props.fileReference.id}
                        onGetFilesCount={setFileCount}
                    />
                }

                {props.linkReference &&
                    <ReferenceLinksPanel
                        hide={selectedTab !== 'links'}
                        reference={props.linkReference}
                        onGetLinksCount={setLinkCount}
                    />
                }

                {props.commentReference &&
                    <CommentPanel
                        hide={selectedTab !== 'comments'}
                        maxHeightPx={props.maxHeightPx}
                        activeUser={activeUser}
                        commentReference={{
                            type: props.commentReference.type,
                            id: props.commentReference.id
                        }}
                        onGetCommentCount={setCommentCount}
                    />
                }
            </Card>
        </Flex>
    );
}